import { Alert, AlertTitle, Typography } from "@mui/material";
import parse from "html-react-parser";

import { severityOptions } from "./updateForm/components/SeverityOption/data/severityOptions";

interface ProductUpdateDisplayProps {
  title: string;
  severity: number;
  content: string;
}

const ProductUpdateDisplay = ({
  title,
  severity,
  content,
}: ProductUpdateDisplayProps) => {
  const { color } = severityOptions[severity];
  return (
    <Alert variant="standard" severity={color}>
      <AlertTitle>
        <Typography variant="h4">{title}</Typography>
      </AlertTitle>
      {parse(content)}
    </Alert>
  );
};
export default ProductUpdateDisplay;
